import { teamMemberService } from "../../../../../Api/Services/TeamMembers";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { IBaseResponse } from "../../../../../Types/UserProfileDetails";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IBulkLeaveParams } from "../../types";

export const teamMembersLeaveBulkApprovedRequestThunk = createServiceAsyncThunk<
  IBaseResponse,
  IBulkLeaveParams
>(
  ACTION_NAMES.UPDATE_BULK_LEAVE_REQUESTS_APPROVED,
  ({ action, comment, leave_id }) =>
    teamMemberService.bulkApproveLeaveRequest({ action, comment, leave_id }),
  ERROR_MESSAGES.UPDATE_BULK_LEAVE_APPROVED_FAILURE
);

export const teamMembersLeaveBulkApprovedRequestSlice = createGenericSlice<
  IBaseResponse,
  IBulkLeaveParams
>(
  SLICE_NAMES.BULK_APPROVED_REQUEST_LEAVE_SLICE,
  teamMembersLeaveBulkApprovedRequestThunk
);

export const {
  clearError: clearTeamMembersLeaveApprovedRequestError,
  clearSuccessMessage: clearTeamMembersLeaveApprovedRequestSuccess,
} = teamMembersLeaveBulkApprovedRequestSlice.actions;

export default teamMembersLeaveBulkApprovedRequestSlice.reducer;
